var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "jb-logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 194.194,
    height: 194.408,
    viewBox: "0 0 194.194 194.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 194.194,
    height: 194.408,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6727",
    "data-name": "Path 6727",
    d: "M187.224,6.089c6.829,6.529,7.678,16.661,6.558,25.5-6.087,37.451-35.533,73.634-61.648,100.618-2.586,2.548-5.19,5.078-7.851,7.55l4.98-10.383-8.8,2.947c2.015-1.9,3.992-3.841,5.969-5.819,24.869-25.326,54.455-60.991,61.4-95.768,2.99-18.449-5.334-27.975-23.8-26.434-17.657,1.562-35.8,10.974-49.33,18.58,15.791-11.015,53.324-33.766,72.522-16.792",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6728",
    "data-name": "Path 6728",
    d: "M124.074,133.958c-3.015,6.322-10.2,21.332-13.307,27.8l-5.151-5.838c-1.487,1.221-3,2.4-4.525,3.576-19.712,15.743-79.216,53.56-97.938,23.847-10.311-19.407,7.137-49.582,16.938-64.562,1.578-2.3,2.509-3.69,2.718-3.975-8.6,15.76-23.457,42.99-17.071,62.907,3.475,10.15,15.085,12,25,10.212,23.723-4.545,45.928-19.54,65.584-34.61,1.372-1.067,2.744-2.153,4.106-3.271l-5.532-6.257c5.545-1.865,23.854-8.022,29.18-9.831",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6729",
    "data-name": "Path 6729",
    d: "M47.7,54.007v92.342a38.781,38.781,0,0,0,30.819-37.926V16.081A38.781,38.781,0,0,0,47.7,54.007",
    fill: "#ff6505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6730",
    "data-name": "Path 6730",
    d: "M92.047,79.275v36.758c.257.006.507.018.764.018a26.922,26.922,0,1,0,0-53.844c-.257,0-.513.012-.764.018Z",
    fill: "#307fe2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJbLogo);
export default __webpack_public_path__ + "static/media/jb-logo.26f28577baf2e39f150870ae923b6538.svg";
export { ForwardRef as ReactComponent };